export const getProfileLinkA11yLabel = (name: string) => `Profile of ${name}`;
